import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Info, Trash2 } from 'react-feather'

import {
    CustomTableData,
    CustomDropDown,
    TooltipInformation,
    TooltipApprovalInfo
} from 'common'

export const ManagementsTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit

    const { fetchAllManagements } = FetchData 
    const { managements } = fetchAllManagements 
    const { handleClickInfoManagement } = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {idcontrato, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation
                        idregistro={idcontrato}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "gestion_fecha", headerName: "FECHA GESTION", minWidth: 160, filter: true },
        { field: "gestion_codigo", headerName: "IDENTIFICADOR", minWidth: 160, filter: true },
        { field: "descripcion", headerName: "GESTIÓN", minWidth: 300, filter: true },
        { field: "contrato_codigo", headerName: "CONTRATO", minWidth: 150, filter: true },
        { field: "nombre", headerName: "DATOS DEL CLIENTE", minWidth: 280, filter: true },
        { field: "descripcion_corta", headerName: "DESCRIPCION DE LA CASA", minWidth: 250, filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 200,
            maxWidth: 200,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'Pendiente Aprobacion') return 'bg-warning';
                if(params.value === 'Pendiente Contrato') return 'bg-warning';
                if(params.value === 'Rechazado') return 'bg-danger';
                if(params.value === 'Aprobado') return 'bg-success';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data
                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )
            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idgestion } = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickInfoManagement(idgestion, 'edit')}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Responder" />
                        </MenuItem>
                        {/* {( ['Pendiente Aprobacion', 'Pendiente Contrato'].includes(aprobacion_check) ) && (
                            <MenuItem
                                onClick={() => handleClickDeleteManagement(idgestion)}
                            >
                                <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                <ListItemText primary="Eliminar" />
                            </MenuItem>
                        )} */}
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={managements}
                columnConfig={columnConfig}
            />
        </div>
    )
}

